import { useEffect, useRef } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";

/** Keep list filters in the URL without allowing a pending list update to close an editor. */
export function useConsignmentListNavigation(searchParams, params, prefix) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const latestPath = useRef(pathname);
  latestPath.current = pathname;
  const editorOpen = !matchPath({ path: `${prefix}/consignment/:page/:size/:params/:orderValue/:orderDirection`, end: true }, pathname);
  const filters = JSON.stringify(searchParams);
  useEffect(() => {
    if (editorOpen || filters === params.params) return;
    const timer = setTimeout(() => {
      if (latestPath.current !== pathname) return;
      navigate(`${prefix}/consignment/${params.page}/${params.size}/${encodeURIComponent(filters)}/${params.orderValue}/${params.orderDirection}`);
    }, 500);
    return () => clearTimeout(timer);
  }, [editorOpen, pathname, filters, params.params, params.page, params.size, params.orderValue, params.orderDirection, prefix, navigate]);
  return editorOpen;
}
